module.exports = __webpack_public_path__ + "assets/img/pexels-christina-morillo-1181438-320.68e60a79.webp";